<template>
    <div>
        <breadcrumbs
            :title="'Vrste skupova'"
            :breadcrumbs="breadcrumbs"
        ></breadcrumbs>
        <div class="ibox">
            <div class="ibox-title">
                <h5>Nova vrsta skupova</h5>
            </div>
            <div class="ibox-content">
                <vrsta-skupa-forma
                    :disabled="false"
                    :id="null"
                    :modal="false"
                    :action="'create'"
                ></vrsta-skupa-forma>
            </div>
        </div>
    </div>
</template>

<script>
import Breadcrumbs from "../../../../components/breadcrumbs/Breadcrumbs";
import VrstaSkupaForma from "./VrstaSkupaForma";
export default {
    name: "VrstaSkupaCreate",
    components: {
        VrstaSkupaForma,
        Breadcrumbs
    },
    data(){
        return {
            breadcrumbs: []
        }
    },
    methods: {
        setBreadcrumbs(){
            this.breadcrumbs = [
                {
                    path: '/postavke/vrste-skupova',
                    name: 'Vrste skupova'
                },
                {
                    path: '/postavke/vrste-skupova/create',
                    name: 'Nova vrsta skupa'
                }
            ]
        }
    },
    mounted(){
        this.setBreadcrumbs()
    }
};
</script>

<style scoped>

</style>
